import { Link } from 'react-router-dom'
import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { useStateValue } from '@State'
import { BasePage } from './BasePage'
import { CreateInvoiceAccountModal } from './CreateInvoiceAccountModal'

const InvoiceAccountsComp = () => {
  const [currentState] = useStateValue()
  const [showModal, setShowModal] = useState(false)

  const toggleModal = () => {
    setShowModal(!showModal)
  }

  return (
    <div className="card-myed">
      <div className="d-flex">
        <h2 className="w-50 mt-1">Invoice Accounts</h2>
        <div className="w-50 text-right">
          <button
            className="btn btn-myed btn-primary btn-primary-myed"
            onClick={() => setShowModal(true)}
          >
            <i className="fa fa-plus" /> Create New Invoice Account
          </button>
        </div>
      </div>
      {currentState.invoiceAccts.map(ia => (
        <Link
          className="text-dec-none"
          key={ia[0]}
          to={`/account/invoice_account_enrollment/invoice_accounts/details/${ia[0]}`}
        >
          <div className="p-5 border rounded mb-3">{ia[1]}</div>
        </Link>
      ))}
      <CreateInvoiceAccountModal show={showModal} toggle={toggleModal} />
    </div>
  )
}

export const InvoiceAccounts = withRouter(InvoiceAccountsComp)

export const InvoiceAccountsPage = () => {
  return (
    <React.Fragment>
      <BasePage Comp={InvoiceAccounts} />
    </React.Fragment>
  )
}
